import { Box, Breadcrumbs, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// components
import ActionFooter from "../../components/ActionFooter";
import FullScreenLoading from "../../components/FullScreenLoading";
import BaseInfo from "../../components/store/BaseInfo";

// api
import { StoreApi } from "../../api/StoreApi";

export default function Create() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState({
    name: "",
    address: "",
    phoneNumber: "",
    inventoryId: null,
    code: "",
    // type: null,
  });
  const [fullScreenLoading, setFullScreenLoading] = useState(false);

  useEffect(() => {}, []);

  const validateForm = () => {
    let hasError = false;

    if (!data.name) {
      hasError = true;
      toast.error(t("Name is required"));
    }

    if (!data.inventoryId) {
      hasError = true;
      toast.error(t("Inventory is required"));
    }

    // if (!data.type) {
    //   hasError = true;
    //   toast.error(t("Type is required"));
    // }

    return hasError;
  };

  const onSubmit = async () => {
    try {
      let error = validateForm();

      if (error) {
        return;
      }

      setFullScreenLoading(true);
      const id = await StoreApi.create(data);
      if (id) {
        toast.success(t("layout.created_successfully"));
        navigate(`/stores`);
      }

    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const onCancel = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="false">
      <FullScreenLoading open={fullScreenLoading} />
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <Link to={"/stores"}>{t("menu.stores")}</Link>
        <Typography color="text.primary">{t("layout.create")}</Typography>
      </Breadcrumbs>
      <Box component="form">
        <BaseInfo data={data} setData={setData} />
        <Box sx={{ my: 8 }} />
        <ActionFooter onSubmit={onSubmit} onCancel={onCancel} />
      </Box>
    </Container>
  );
}
